import { render } from "./ModalCompletarVenta.vue?vue&type=template&id=9c6f1810"
import script from "./ModalCompletarVenta.vue?vue&type=script&lang=js"
export * from "./ModalCompletarVenta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__